import { Navigate, Outlet } from 'react-router-dom';
import { usePendingPasswordSetup } from '../lib/authFlow';

// Route guard: an invited (or recovering) user who has not yet chosen a password is held on
// /set-password and admitted nowhere else. Sits inside RequireAuth — the session already
// exists at this point; what is missing is the password behind it.
export function RequirePasswordSetup(): JSX.Element {
  const pending = usePendingPasswordSetup();

  if (pending !== null) {
    return <Navigate to="/set-password" replace />;
  }
  return <Outlet />;
}
